<template>
    <section class="h-100" v-loading="process.loading">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     @review="handleReview"
                     :btn_add="false"
                     :btn_delete="false"
                     :btn_edit="false"
                     btn_review
        >
        </front-table>

        <div class="clearfix"></div>

        <meeting-view v-if="model === 'Admin.Approve'"
                      :view_mode="view_mode" :single="single"
                      :btn_start_meeting="false"
                      btn_approve
                      @approve="handleApprove"
                      @cancel="view_mode = false">
        </meeting-view>
        <visitor-view v-if="model === 'Admin.User.Approve'"
                      :view_mode="view_mode" :single="single"
                      btn_approve
                      @approve="handleApprove"
                      @cancel="view_mode = false">
        </visitor-view>
    </section>
</template>

<script>
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";
    import MeetingView from "../components/meeting-view";
    import VisitorView from "../components/visitor-view";
    import {mapState} from 'vuex';

    export default {
        mixins: [FrontMixins],
        name: 'approve',
        components: {VisitorView, FrontTable, MeetingView},
        created() {
            if (this.$route.meta && this.$route.meta.model) this.model = 'Admin.' + this.$route.meta.model;
            else this.model = 'Admin.Approve';
        },
        computed:{
            ...mapState(['process'])
        },
        methods: {
            handleApprove(data) {
                this.view_mode = false;
                data.id = this.single.id;
                this.$api(this.model + '.Approve', data, 1).then(() => {
                    this.$messageBox.success('审批完成');
                    this.reload();
                });
            }
        }
    }
</script>

<style scoped>

    .page-label {
        width: 80px;
        text-align: left;
        font-weight: bold;
        display: inline-block;
        line-height: 30px;
    }

</style>
